var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#474747"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 5.33325V15.9999H6.6665L9.33317 18.6666L11.9998 15.9999H9.99984V5.33325H8.6665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 12.6666H17.3332V13.6666L13.9998 17.9999H17.3332V18.6666H12.6665V17.6666L15.9998 13.3333H12.6665V12.6666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3332 5.33325H16.6665L17.3332 5.99992V11.3333H15.9998V9.33325H13.9998V11.3333H12.6665V5.99992L13.3332 5.33325ZM13.9998 5.99992H15.9998V8.66658H13.9998V5.99992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/SortAscending.b39fc80e0575110108cd4baf05301f6d.svg";
export { ForwardRef as ReactComponent };